import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import md5 from 'js-md5'
import urls from '../common/js/urls.js'

export function api_content_page_nav(context) {
  var promise = new Promise(function (resolve, reject) {
    var domain = window.location.host;
    var application_id = 1;
    if (domain == 'runyu.winlesson.com' || domain == 'www.runyubisheng.com') {
      application_id = 300;
    }
    axios.get(urls.index + "?from=android&ver=6.6.0&application_id=" + application_id).then((response) => {
      var res = response.data;
      var index_nav = [];
      // 导航条
      for (var i = 0; i < res.category_list.length; i++) {
        var item = res.category_list[i];
        var nav_item = {
          category_type: item.category_type,
          en_title: item.en_title,
          title: item.title,
          category_weburl_content: item.category_weburl_content,
          id: item.id,
          content_page_id: item.content_page_id,
        };
        index_nav.push(nav_item);
      }
      resolve(index_nav);
    }).catch((response) => {
      reject(response);
    })
  });
  return promise;
};

export function api_content_sy_page(context) {
  var promise = new Promise(function (resolve, reject) {
    var domain = window.location.host;
    var application_id = 1;
    if (domain == 'runyu.winlesson.com' || domain == 'www.runyubisheng.com') {
      application_id = 300;
    }
    axios.get(urls.by_page + "?ver=6.6.0&page_id=0" + "&application_id=" + application_id).then((response) => {
    //  var page_content = response.data.category_list[0];
      var page_content = response.data.cate_info;
      var r = {
        "context": context,
        "page_id": '0',
        "page_content": page_content,
      }
      resolve(r);
    }).catch((response) => {
      reject(response);
    })
  });

  return promise;
};


export function api_content_operation_page(context, page_id) {
  var promise = new Promise(function (resolve, reject) {
    var domain = window.location.host;
    var application_id = 1;
    if (domain == 'runyu.winlesson.com' || domain == 'www.runyubisheng.com') {
      application_id = 300;
    }
    axios.get(urls.by_page + '?page_id=' + page_id + "&from=web" + "&application_id=" + application_id).then((response) => {
      var page_content = response.data.cate_info;
      var r = {
        "context": context,
        "page_id": page_id,
        "page_content": page_content,
      }
      resolve(r);

    }).catch((response) => {
      reject(response);
    })
  });

  return promise;
};





// WEBPACK FOOTER //
// ./src/networks/ContentOperationHandler.js